<template>
  <router-link
    v-slot="{ isExactActive }"
    :to="url"
    exact
    class="group lg:px-2 h-full px-1"
  >
    <div
      class="flex items-center h-full border-b-[3px]"
      :class="{
        'border-transparent group-hover:border-gray-300': !isExactActive,
        'border-primary-500': isExactActive
      }"
    >
      <i
        class="text-[22px] mdi mr-1 lg:mr-2"
        :class="[{
          'group-hover:text-primary-600 text-gray-500': !isExactActive,
          'text-primary-600': isExactActive
        }, 'mdi-' + icon]"
      />
      <span
        class="lg:text-base text-sm"
        :class="{
          'group-hover:text-primary-600 text-gray-500': !isExactActive,
          'text-primary-600': isExactActive
        }"
      >{{ title }}</span>
    </div>
  </router-link>
</template>
<script>
export default {
  props: {
    title: {
      required: true,
      type: String
    },
    url: {
      required: true,
      type: String
    },
    icon: {
      required: true,
      type: String
    }
  }
};
</script>
